import { render } from "./GrupalChat.vue?vue&type=template&id=644b602f&scoped=true"
import script from "./GrupalChat.vue?vue&type=script&lang=js"
export * from "./GrupalChat.vue?vue&type=script&lang=js"

import "./GrupalChat.vue?vue&type=style&index=0&id=644b602f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644b602f"]])

export default __exports__